import { TEt3Font } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Et3Text = withLiteObserverAndTheme<TEt3Font>((props) => {
  const { isSpan, fontFamily, fontSize, text, style, theme, color } = props;
  const { getFontType, getFontSize } = theme;

  return isSpan ? (
    <span
      style={{
        fontFamily: getFontType(fontFamily),
        fontSize: getFontSize(fontSize),
        color: color,
        ...style
      }}
    >
      {text}
    </span>
  ) : (
    <p
      style={{
        fontFamily: getFontType(fontFamily),
        fontSize: getFontSize(fontSize),
        color,
        textAlign: "center",
        wordWrap: "break-word",
        ...style
      }}
    >
      {text}
    </p>
  );
});
export default Et3Text;
